import React, { Component } from "react";
import {
  Button,
  FormControl,
  Input,
  Dialog,
  Typography,
  Zoom,
  CircularProgress,
  InputLabel,
  Paper,
  IconButton,
  Grid,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { connect } from "react-redux";
import { msgSimple } from "../../actions/snackbarActions";
import { login } from "../../actions/authActions";
import UserService from "../../tools/UserService";
import logo from "../../images/logo-sem-fundo.png";
import { colors } from "../../styles";

class Login extends Component {
  state = {
    email: "",
    password: "",
    forgot: false,
    loading: false,
    showPassword: false,
  };

  handleLogin = async () => {
    const { email, forgot } = this.state;

    this.setState({ loading: true });

    if (!forgot) {
      await this.props.login({ email, password: this.state.password });
    } else {
      this.forgotPassword();
    }

    this.setState({ loading: false });
  };

  handleForgotPassword = () => {
    const { email } = this.state;

    UserService.forgotPassword(email)
      .then((result) => {
        if (result.ok) {
          this.props.msgSimple(`E-mail enviado para ${email}`);
          this.setState({ forgot: false });
        } else {
          this.props.msgSimple("E-mail não encontrado.");
        }
      })
      .catch(() => {
        this.props.msgSimple("Erro! Por favor, contate o suporte: " + email);
      })
      .finally(() => this.setState({ loading: false }));
  };

  toggleForgotState = () => {
    this.setState((prevState) => ({ forgot: !prevState.forgot }));
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  renderButtonLabel = () => {
    const { forgot, loading } = this.state;

    if (loading) {
      return <CircularProgress size={16} style={{ color: "white" }} />;
    }
    return forgot ? "ENVIAR" : "ENTRAR";
  };

  renderForgotOrBackButton = () => {
    const { forgot } = this.state;

    return (
      <FormControl
        fullWidth
        onClick={this.toggleForgotState}
        style={{ fontSize: 12, textAlign: "center", cursor: "pointer" }}
      >
        <Typography>{forgot ? "Voltar" : "Esqueci minha senha"}</Typography>
      </FormControl>
    );
  };

  render() {
    const { email, password, forgot, showPassword } = this.state;

    return (
      <main style={styles.layout}>
        <Grid container style={{ height: "100%" }}>
          <Grid item xs={4}></Grid>
          <Grid
            item
            xs={4}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 24,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={logo} alt="airshuttle" style={{ height: 50 }} />
            </div>
            <Paper style={styles.paper}>
              {forgot && (
                <div style={{ marginTop: 15, textAlign: "center" }}>
                  <Typography>
                    Informe seu e-mail e enviaremos instruções para você fazer
                    login em sua conta.
                  </Typography>
                </div>
              )}

              <form style={styles.form}>
                <Zoom in={true}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="email">E-mail</InputLabel>
                    <Input
                      id="email"
                      name="email"
                      autoComplete="email"
                      value={email}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") this.handleLogin();
                      }}
                      onChange={(event) =>
                        this.setState({ email: event.target.value })
                      }
                    />
                  </FormControl>
                </Zoom>
                {!forgot && (
                  <Zoom in={!forgot}>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="password">Senha</InputLabel>
                      <Input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        value={password}
                        endAdornment={
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.togglePasswordVisibility}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        }
                        onKeyDown={(event) => {
                          if (event.key === "Enter") this.handleLogin();
                        }}
                        onChange={(event) =>
                          this.setState({ password: event.target.value })
                        }
                      />
                    </FormControl>
                  </Zoom>
                )}

                {this.renderForgotOrBackButton()}

                <Button
                  variant="contained"
                  color="primary"
                  style={styles.submit}
                  onClick={this.handleLogin}
                  fullWidth
                >
                  {this.renderButtonLabel()}
                </Button>

                <Typography style={{ textAlign: "center", marginTop: "20px" }}>
                  Para dúvidas e possíveis problemas, entre em contato:{" "}
                  <span>airshuttle@mandatech.com.br</span>
                </Typography>
              </form>
            </Paper>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

const mapDispatchToProps = {
  login,
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);

const styles = {
  layout: {
    backgroundColor: colors.primary_darker,
    height: "100vh",
  },
  paper: {
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 30,
    width: 350,
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: 20,
  },
  submit: {
    marginTop: 30,
  },
};



// WEBPACK FOOTER //
// ./src/routes/login/index.js